// @ts-ignore

type HeaderProps = {
  title: string;
  onMenuClick: () => void;
  onThemeToggle?: () => void;
  isMinimized?: boolean;
};

export default function Header({ title }: HeaderProps) {
  
  return (
    <header aria-label={`${title} page header`}>
      <div className="flex items-center">
        <h5 className="text-xl font-medium">{title}</h5>
      </div>
    </header>
  );
}
